var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFritFiskeri(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "5.5mm",
    height: "5.5mm",
    viewBox: "0 0 15.591 15.591",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 15.591,
    height: 15.591,
    rx: 7.795,
    fill: "#0072bc"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.589,3.72A1.322,1.322,0,1,0,8.82,4.951v6.1a1.241,1.241,0,0,1-2.482,0V10.8a.447.447,0,0,0,.667-.541l-.7-1.68a.448.448,0,0,0-.861.173v2.3a2.137,2.137,0,0,0,4.274,0v-6.1A1.314,1.314,0,0,0,10.589,3.72ZM9.268,3.3a.426.426,0,1,1-.426.425A.426.426,0,0,1,9.268,3.3Z",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFritFiskeri);
export default __webpack_public_path__ + "static/media/FRIT-FISKERI.c7e2c51152f42c5f37026091f55b2023.svg";
export { ForwardRef as ReactComponent };